






















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class DownlineBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: object;

  @Prop() readonly report!: Function;

  @Prop() readonly lock!: Function;

  @Prop() readonly editInfo!: Function;

  @Prop() readonly resetPassword!: Function;

  @Prop() readonly editPT!: Function;

  @Prop() readonly refillCredit!: Function;

  @Prop() readonly deductCredit!: Function;

  @Prop() readonly handleSub!: Function;

  @Prop() readonly startCount!: number;

  isSub = ['SUBACCOUNT', 'SUBAGENT', 'SUBCOMPANY'].includes(this.AuthInstance.user.role)

  isAdmin = ['ADMIN', 'SUPERADMIN'].includes(this.AuthInstance.user.role)

  isParent = false;

  editAgent(id) {
    this.$router.push({ name: 'EditAgent', params: { id } });
  }

  editMember(id) {
    this.$router.push({ name: 'EditMember', params: { id } });
  }

  isSuspend(user) {
    if (user.isSuspend) {
      return 'isSuspend';
    } else {
      return '';
    }
  }

  checkPerm = utils.getUserPersistent().user.userPermission.member === 'edit';

  isAbleToEdit(userLevel: number): boolean {
    this.isParent = userLevel === (this.isSub ? this.AuthInstance.user.level
      : this.AuthInstance.user.level + 1);
    if ((this.checkPerm && this.isParent) || this.isAdmin) {
      return true;
    } else {
      return false;
    }
  }
}
